export enum Browsers {
	Chrome="Chrome",
	Firefox="Firefox",
	Safari="Safari",
	IE="IE",
	//What is Edge?
	//...What are others
}
